import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { toast } from "react-toastify";
import style from "./style";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

const SimulateNotificationView = ({
  isSimulating = false,
  disabled = true,
  notification = {},
  handleCancelSimulate = () => {},
  handleSimulateConfirmation = () => {},
  simulate = false,
  simulateError = false,
  simulateSuccess = false,
  isStatusOff = false,
  handleSimulateClose = () => {},
  handleSimulateSave = () => {},
  handleSimulateDialog = () => {},
}) => {
  return (
    <>
      <Button
        // className={passedClasses.button}
        // color="primary"
        sx={
          !(isSimulating || disabled || isStatusOff) && { ...style.textColor }
        }
        disabled={isSimulating || disabled || isStatusOff}
        onClick={() => {
          if (true) {
            handleSimulateDialog();
          } else {
            toast.error("Turned off notification cannot be simulated.");
          }
        }}
        startIcon={
          <img
            alt=""
            src={
              isSimulating || disabled || isStatusOff
                ? "/assets/phone-disabled.svg"
                : "/assets/phone.svg"
            }
          />
        }
        variant="outlined"
      >
        <Typography variant="button">Simulate</Typography>
      </Button>
      <Dialog open={simulate}>
        <DialogContent sx={{ maxWidth: "400px", maxHeight: "400px" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Simulate Notification</Typography>
            <IconButton>
              <CloseIcon
                sx={{ color: "grey.600" }}
                fontSize="small"
                onClick={handleCancelSimulate}
              />
            </IconButton>
          </Box>
          <Typography variant="subtitle2">
            Initiate a test on your notification and simulate a real trigger.
            The simulated test notification will be delivered by the methods you
            have choosen and "test" will be clearly labeled in the message
            content.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelSimulate}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSimulateConfirmation}
            variant="contained"
            color="secondary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* <ActionDialog
        classes={
          dialogState.simulateError
            ? passedClasses.simulateError
            : passedClasses.simulateSuccess
        }
        contentText={
          dialogState.simulateError ? (
            <>
              <Typography className="color-error" variant="body1">
                Notification could not be simulated.
              </Typography>
              <p>
                Check your delivery destinations and verify your notification to
                ensure the number, trigger and delivery method are valid.
              </p>
            </>
          ) : (
            `Check the destination for notification you simulated to ensure 
        you have successfully received your notification.`
          )
        }
        heading={
          dialogState.simulateError ? (
            <span className="color-error">Simulation Error</span>
          ) : (
            "Notification Simulated!"
          )
        }
        isConfirmation
        onClose={() =>
          setDialogState((prevState) => ({
            ...prevState,
            simulateError: false,
            simulateSuccess: false,
          }))
        }
        onConfirm={() =>
          setDialogState((prevState) => ({
            ...prevState,
            simulateError: false,
            simulateSuccess: false,
          }))
        }
        open={dialogState.simulateError || dialogState.simulateSuccess}
        positiveActionLabel="Ok"
      /> */}
      <Dialog open={simulateError || simulateSuccess}>
        <DialogContent>
          <Typography variant="h6">
            {simulateError ? (
              <span className="color-error">Simulation Error</span>
            ) : (
              "Notification Simulated!"
            )}
          </Typography>
          <Typography variant="subtitle2">
            {simulateError ? (
              <>
                <Typography className="color-error" variant="body1">
                  Notification could not be simulated.
                </Typography>
                <p>
                  Check your delivery destinations and verify your notification
                  to ensure the number, trigger and delivery method are valid.
                </p>
              </>
            ) : (
              `Check the destination for notification you simulated to ensure 
        you have successfully received your notification.`
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSimulateClose}
            sx={{ color: "grey.600", mr: 4 }}
            variant="text"
          >
            Cancel
          </Button>
          <Button onClick={handleSimulateSave} variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SimulateNotificationView;
